import { HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ResourceManager } from '../../../components/resource-manager/resource-manager.component';
import { InspirationRoomsResultModel } from '../../../models/InspirationRoomsResultModel';
import { InspirationRoomService } from '../../services/inspiration-rooms/inspiration-room.service';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { Globals } from '../../../services/globals';
import { InspirationRoomModel } from '../../../models/InspirationRoomModel';
import { AreasService } from '../../../services/areas.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { InspirationGroup } from '../../../models/InspirationGroupModel';
import { InspirationGroupService } from '../../../services/inspiration-group.service';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { map, startWith } from "rxjs/operators";
import { forkJoin, Observable } from 'rxjs';
import { InspirationRoomOptionModel } from '../../../models/InspirationRoomOptionModel';
import { OptionSelectorService } from '../../services/option-selector.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: 'gallery-component',
  templateUrl: 'gallery.component.html',
  styleUrls: ['gallery.component.css'],
  host: {
    '(window:resize)': 'windowResized($event)',
    '(window:orientationchange)': 'windowResized($event)'
  }
})

export class GalleryComponent implements AfterViewInit {
  @ViewChild('gridContainer', { static: true }) gridContainer: ElementRef;

  areas: any = [];
  inspirationGroup: InspirationGroup[];
  gridByBreakpoint = {
    xl: 5,
    lg: 4,
    md: 3,
    sm: 2,
    xs: 1
  };
  // Default to 4 columns
  gridColumns: number;
  gridRowHeight = 140;
  gridGutterSize = 20;
  isRequired = false;
  inspirationRoomsPage: InspirationRoomsResultModel;
  roomsIdDisplayOrder: { id: number, displayOrder: number }[];
  pageIndex = 0;
  roomsPerPage = 12;
  selectedStatus: string = 'all';

  filter = "";
  //selectedArea: number = 0;

  selectedGroup: number = 0;
  searchTimeout: any;
  displaySearch = true;
  defaultLanguage: string = 'en';
  nameUpdate = "";
  roomId: number;
  loadingText = "Loading...";
  filteredOptionIds: string[] = [];
  refreshingOptions = false;

  // Bootstrap Screen Width
  private XS_SCREEN = 568;
  private S_SCREEN = 768;
  private L_SCREEN = 992;
  private XL_SCREEN = 1200;

  myControl = new UntypedFormControl();
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  filteredOptions: Observable<InspirationRoomOptionModel[]>;
  public availableOptions: InspirationRoomOptionModel[];

  constructor(private inspirationRoomService: InspirationRoomService,
    private areasService: AreasService,
    private router: Router,
    private resourceManager: ResourceManager,
    private toastr: ToastrService,
    private globals: Globals,
    public optionsService: OptionSelectorService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private breakpointObserver: BreakpointObserver,
    private inspirationGroupService: InspirationGroupService,
    private renderer: Renderer2) {
    this.ngxUiLoaderService.start();
    globals.hideHeader = false;
    forkJoin([this.globals.getGlobalOptions(false),
    this.getInspirationRoomsOptions()])
      .subscribe(x => {
        this.getInspirationGroups(),
          this.loadMedia(true)
      })

    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge,
    ]).subscribe(result => {
      if (result.matches) {
        if (result.breakpoints[Breakpoints.XSmall]) {
          this.gridColumns = this.gridByBreakpoint.xs;
        }
        if (result.breakpoints[Breakpoints.Small]) {
          this.gridColumns = this.gridByBreakpoint.sm;
        }
        if (result.breakpoints[Breakpoints.Medium]) {
          this.gridColumns = this.gridByBreakpoint.md;
        }
        if (result.breakpoints[Breakpoints.Large]) {
          this.gridColumns = this.gridByBreakpoint.lg;
        }
        if (result.breakpoints[Breakpoints.XLarge]) {
          this.gridColumns = this.gridByBreakpoint.xl;
        }
      }
    });
  }

  getIcon(displayOrder: number, index: number) {
    return (displayOrder && displayOrder > 0 ? displayOrder : index + 1).toString();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.inspirationRoomsPage?.rooms, event.previousIndex, event.currentIndex);
    this.setDisplayOrder();
  }

  setDisplayOrder() {
    const roomIds = this.inspirationRoomsPage?.rooms.map(x => x.id)
    this.roomsIdDisplayOrder = [];
    for (let room of this.inspirationRoomsPage?.rooms) {
      let displayOrder = roomIds.indexOf(room.id) + 1
      let roomIdDisplayOrder = { id: room.id, displayOrder: displayOrder }
      room.displayOrder = displayOrder;
      this.roomsIdDisplayOrder.push(roomIdDisplayOrder)
    }
    if (this.roomsIdDisplayOrder && this.roomsIdDisplayOrder.length) {
      this.optionsService.updateDisplayOrder(this.roomsIdDisplayOrder).subscribe();
    }
  }

  getInspirationRoomsOptions() {
    return new Promise<boolean>(res => {
      this.ngxUiLoaderService.start();
      this.optionsService.getInspirationRoomsOptions().subscribe(response => {
        console.log('getInspirationRoomsOptions response:', response);
        this.ngxUiLoaderService.stop();
        this.availableOptions = response;
      }, error => {
        console.error('Error in getInspirationRoomsOptions:', error);
        this.ngxUiLoaderService.stop();
      });

      res(true);
    });
  }

  onSwipe(evt) {
    // Check for sensitivity
    if (Math.abs(evt.deltaX) > 40) {
      if (evt.deltaX > 0) {
        this.prevRecord();
      }
      else {
        this.nextRecord();
      }
    }
  }

  windowResized(event) {
    const windowWidth = +event.target.innerWidth;

    this.displaySearch = true;

    if (windowWidth < this.XS_SCREEN) {
      this.gridColumns = 1;
      this.displaySearch = false;
    } else if (windowWidth < this.S_SCREEN) {
      this.gridColumns = 2;
      this.displaySearch = false;
    } else if (windowWidth < this.L_SCREEN) {
      this.gridColumns = 3;
    }
    else {
      this.gridColumns = 4;
    }
  }

  ngAfterViewInit() {
    this.ngxUiLoaderService.start();
    this.preloadComponentImages();
    this.loadAutoComplete()
    this.ngxUiLoaderService.stop();

    setTimeout(() => {
      const element: HTMLElement = document.getElementById('search') as HTMLElement;

      if (element !== null) {
        element.focus();
      }
    }, 1000);
  }

  loadAutoComplete() {
    setTimeout(() => {
      this.filteredOptions = this.myControl.valueChanges
        .pipe(startWith(''), map(value => this._filter(value)));

      var elem = this.renderer.selectRootElement('#autocomplete');
      this.renderer.listen(elem, "focus", () => { });
      this.renderer.listen(elem, "blur", () => { });
      elem.focus();
      this.autocomplete.closePanel();
    }, 1000);
  }

  private _filter(value: string): InspirationRoomOptionModel[] {
    // Check for null, undefined, or empty strings
    if (!value) return;

    const filterValue = value.toLowerCase();
    const filtered = this.availableOptions.filter(o => (o.displayName && o.displayName?.toLowerCase().includes(filterValue)));
    const distincOptions = filtered.filter((option, i, arr) => arr.findIndex(t => t.displayName === option.displayName) === i);
    if (distincOptions.length < 10) return distincOptions;

    return distincOptions.slice(0, 10);
  }

  onSearchChange(searchValue: string) {
    this.filteredOptionIds = [];
    this.pageIndex = 0;
    this.filter = searchValue;
    localStorage.setItem("searchValue", this.filter.toString());
    clearTimeout(this.searchTimeout);
    const base = this;
    this.searchTimeout = setTimeout(function () {
      if (base.filter && base.filter != "" && base.globals.globalOptions) {
        base.filteredOptionIds = base.globals.globalOptions.filter(x => x.model != null && x.model.includes(searchValue) || x.code != null && x.code.includes(searchValue)).map(({ optionId }) => optionId.toString());
      } base.loadMedia(false);
    }, 1200);
  }

  preloadComponentImages() {
    if (!this.resourceManager.isDefaultLoaded) {
      this.resourceManager.loadDefaultImages();
    }
  }

  prevRecord() {
    if (this.pageIndex !== 0) {
      this.pageIndex = this.pageIndex - 1;
      this.loadMedia(false);
    }
  }

  nextRecord() {
    if (this.pageIndex < this.inspirationRoomsPage.totalPages) {
      this.pageIndex = this.pageIndex + 1;
      this.loadMedia(false);
    }
  }

  onGroupChange() {
    this.pageIndex = 0;
    clearTimeout(this.searchTimeout);
    const base = this;
    localStorage.setItem("group", this.selectedGroup.toString())
    this.searchTimeout = setTimeout(function () {
      base.loadMedia(false);
    }, 500);
  }

  loadMedia(isLoader: boolean) {   
    let group = localStorage.getItem("group")!=null? parseInt(localStorage.getItem("group")):0;
    let status = localStorage.getItem("status") != null ? localStorage.getItem("status") : "all";
    let filterBy = localStorage.getItem("searchValue") != null ? localStorage.getItem("searchValue") : "";

    this.selectedGroup.toString() == "0" ? this.selectedGroup = group : this.selectedGroup = this.selectedGroup;
    this.selectedStatus.toString() == "all" ? this.selectedStatus = status : this.selectedStatus = this.selectedStatus;
     this.myControl.setValue(filterBy);
    if (isLoader) {
      this.ngxUiLoaderService.start();
    }
    const params = new HttpParams()
      .set("pageIndex", this.pageIndex.toString())
      .set("roomsPerPage", this.roomsPerPage.toString())
      .set("filter", filterBy)
      .set("userId", localStorage.getItem("userId"))
      .set("group", group.toString())  
      .set("status", status)
      .set("optionIds", this.filteredOptionIds.toString());

    this.inspirationRoomService.loadMedia(params).subscribe(result => {
      this.inspirationRoomsPage = result;
      if (this.inspirationRoomsPage?.rooms && this.inspirationRoomsPage.rooms.length) {
        for (let room of this.inspirationRoomsPage.rooms) {
          this.setOptionsCount(room);
        }
      }
      this.loadingText = "No Data Found"
      this.ngxUiLoaderService.stop();
    }, error => {
      this.loadingText = "No Data Found"
      this.ngxUiLoaderService.stop();
    });
  }

  openResizer(room: InspirationRoomModel) {
    const id = room.backgroundId;
    this.roomId = room.id;
    this.globals.insperationalRoomId = this.roomId;
    this.router.navigate([`/resizer/${id}/${1}/${this.roomId}`]);
  }

  loadAreas() {
    this.areasService.getAreas().subscribe(result => {
      this.areas = result;
    });
  }

  imageLoaded(img) {
    img.target.classList.add("loaded");
  }

  toggleActiveStatus(room: InspirationRoomModel) {
    room.isActive = !room.isActive;
    this.inspirationRoomService.updateRoom(room).subscribe(response => {
      room.isActive = response.isActive;
      this.loadMedia(false);
    }, error => console.error(error));
  }

  toggleStaged(room: InspirationRoomModel) {
    room.isStaged = !room.isStaged;
    this.inspirationRoomService.updateRoom(room).subscribe(response => {
      room.isStaged = response.isStaged;
      //this.loadMedia(false);
    }, error => console.error(error));
  }

  deleteRoom(room: InspirationRoomModel) {
    Swal.fire({
      title: 'Delete',
      text: `Are you sure you want to remove this room?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Yes, delete it!`,
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        this.inspirationRoomService.deleteRoom(room.id).subscribe(response => {
          this.toastr.success(`Room has been deleted successfully.`, "Success!");
          this.loadMedia(false);
        }, error => console.error(error));
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    });
  }

  handleName(name: string) {
    this.nameUpdate = name;
  }

  cancelName(id) {
    for (let i = 0; i < this.inspirationRoomsPage.rooms.length; i++) {
      if (this.inspirationRoomsPage.rooms[i].id === id) {
        this.inspirationRoomsPage.rooms[i].name = this.nameUpdate;
        return;
      }
    }
  }

  updateName(room: InspirationRoomModel) {
    this.ngxUiLoaderService.start();
    this.inspirationRoomService.updateRoom(room).subscribe(response => {
      this.ngxUiLoaderService.stop();
      this.toastr.success(`Room name has been successfully updated`, "Success!");
    });
  }

  saveOnEnter(room) {
    if (room.name == "") {
      this.isRequired = true;
      return;
    }
    else {
      this.updateName(room);
      this.isRequired = false;
    }
  }

  getInspirationGroups() {
    this.ngxUiLoaderService.start();
    this.inspirationGroupService.getInspirationGroups().subscribe(inspirationGroup => {
      this.inspirationGroup = inspirationGroup;
      this.ngxUiLoaderService.stop();
    });
  }

  gotoRoom(room: InspirationRoomModel) {
    this.globals.allRooms = this.inspirationRoomsPage?.rooms;
    localStorage.setItem("AllRooms", JSON.stringify(this.globals.allRooms));
    this.router.navigate(['/edit/' + room.id]);
  }

  get getAllRooms(): InspirationRoomModel[] {
    return this.inspirationRoomsPage?.rooms
  }

  setOptionsCount(room: InspirationRoomModel) {
    if (room.optionCountSet) {
      return;
    }

    if (this.availableOptions.some(x => x.roomId == room.id)) {
      room.options = this.availableOptions.filter(x => x.roomId == room.id)
      if (room && room.options && room.options.length) {

        let optionsCount = room.options.length;
        let stylesCount = room.options.flatMap(x => x.styleSelections).length;
        room.totalTagsCount = optionsCount + stylesCount;

        let inactiveOptions = room.options.filter(x => !this.globals.getAllGobalOption().map(x => x.optionId).includes(x.optionId)).length;
        let styles = room.options.filter(x => x.styleSelections && x.styleSelections.length).flatMap(x => x.styleSelections.flatMap(q => q.styleSelectionId))
        let activeOptions = this.globals.getAllGobalOption().filter(x => room.options.map(x => x.optionId).includes(x.optionId))
        let availabeStyles = activeOptions.filter(x => x.styleSelections && x.styleSelections.length).flatMap(x => x.styleSelections.flatMap(q => q.optionId))

        let existStyleSelections = room.options.filter(x => x.styleSelections && x.styleSelections.length).flatMap(x => x.styleSelections)
        let currentActivStyles = activeOptions.filter(x => x.styleSelections && x.styleSelections.length).flatMap(x => x.styleSelections)

        let inactiveSelectedStyles = 0
        for (let styleSelection of existStyleSelections) {
          if (currentActivStyles.some(x => x.optionId == styleSelection.styleSelectionId) && styleSelection.styleId > 0) {
            let activeStyle = currentActivStyles.find(x => x.optionId == styleSelection.styleSelectionId)
            if (!activeStyle.styleChoices.some(x => x.optionId == styleSelection.styleId)) {
              inactiveSelectedStyles++;
            }
          }
        }

        let inactiveColorList = styles.filter(x => !availabeStyles.includes(x)).length;
        room.inactiveOptionCount = inactiveOptions + inactiveColorList + inactiveSelectedStyles;
        room.optionCountSet = true;
        room.hasInactiveOptions = room.inactiveOptionCount > 0;
      }
    }
  }

  refreshGlobalOptionsJson() {
    this.refreshingOptions = true;
    this.optionsService.getGlobalOptions(true).subscribe(response => {
      this.globals.globalOptions = response;
      this.refreshingOptions = false;
      this.toastr.success(`All options have been refreshed with the latest available data.`, "Success!");
    });
  }

  
  exportInspirationRooms(isLoader: boolean) {
    if (isLoader) {
      this.ngxUiLoaderService.start();
    }
    const params = new HttpParams()
      .set("pageIndex", this.pageIndex.toString())
      .set("roomsPerPage", this.roomsPerPage.toString())
      .set("filter", this.filter)
      .set("userId", localStorage.getItem("userId"))
      .set("group", this.selectedGroup.toString())
      .set("optionIds", this.filteredOptionIds.toString())
      .set("roomId",0);
    this.inspirationRoomService.exportInspirationRooms(params).subscribe(result => {
      const detailedReport: any = result.data;
      const linkSource = 'data:application/pdf;base64,' + detailedReport;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = result.fileName;
      downloadLink.click();
      //this.loader.stop();
    
  
    }, error => {
      this.loadingText = "No Data Found"
      this.ngxUiLoaderService.stop();
    });
  }

  onLiveStatusChange() {
    this.pageIndex = 0;
    this.refreshingOptions = true;
    localStorage.setItem("status", this.selectedStatus.toString());

    this.loadMedia(false);
    this.refreshingOptions = false;
  }
}
